import axiosInstance from './axiosInstance';

export const employeeApi = {
  getEmployees: (params) => axiosInstance.get('/employees', { params }),
  createEmployee: (data) => axiosInstance.post('/employees', data),
  getIdConfigs: () => axiosInstance.get('/employees/id-configs'),
  updateIdConfig: (companyId, data) => axiosInstance.put(`/employees/id-configs/${companyId}`, data),
  getLimitRequests: (params) => axiosInstance.get('/employee-limits/requests', { params }),
  approveLimitRequest: (id, data) => axiosInstance.post(`/employee-limits/requests/${id}/approve`, data),
  rejectLimitRequest: (id, data) => axiosInstance.post(`/employee-limits/requests/${id}/reject`, data),
  createLimitRequest: (data) => axiosInstance.post('/employee-limits/requests', data)
};
